<template>
  <!-- 活动中 -->
  <div :class="$style.box">
    <!-- 活动页顶部 -->
    <div
      :class="$style.top"
      :style="{ backgroundImage: `url('${this.$cdnUrl}/imperialGlory/bg01.jpg?v=1')` }"
    >
      <p>
        <span v-if="todaySignIn == 1">今日已签到，</span>累计签到
        <span :class="$style.red">{{ totalSignInDay }}</span> 天
      </p>
      <span @click="jumpCircle">去圈子逛逛</span>
      <div :class="$style.mession">
        <span>完成圈子注册</span>
        <span v-if="task1 !== 1" @click="CHANGE_REGISTER_DIALOG(true)"
          >去注册<span :class="$style.after"></span
        ></span>
        <span v-else>已完成<img :src="`${$cdnUrl}/imperialGlory/done.png`" alt="" /></span>
      </div>
      <div :class="$style.mession">
        <span>去圈子点击一篇帖子</span>
        <span v-if="task2 !== 1" @click="jumpCircle"
          >去圈子<span :class="$style.after"></span
        ></span>
        <span v-else>已完成<img :src="`${$cdnUrl}/imperialGlory/done.png`" alt="" /></span>
      </div>
    </div>
    <!-- 礼包福利 -->
    <div
      :class="$style.gift"
      :style="{ backgroundImage: `url('${$cdnUrl}/imperialGlory/bg02.jpg')` }"
    >
      <div v-for="(item, index) in giftList" :key="index" @click="getGift(item)">
        <img :class="$style.giftItem" :src="item.imgUrl" alt="" />
        <img
          v-if="item.status === 1"
          :class="$style.giftBtn"
          :src="`${$cdnUrl}/imperialGlory/gift_get.png`"
          alt=""
        />
        <img
          v-if="item.status === 2"
          :class="$style.giftBtn"
          :src="`${$cdnUrl}/imperialGlory/gift_done.png`"
          alt=""
        />
      </div>
    </div>
    <!-- 抽奖福利 -->
    <div
      :class="$style.lottery"
      :style="{ backgroundImage: `url('${$cdnUrl}/imperialGlory/bg03.jpg')` }"
    >
      <span @click="showLotteryRecord">中奖记录</span>
      <p>累计签到 <span>5</span> 天、<span>10</span> 天可分别获得1次抽奖机会</p>
      <div>
        <img :src="`${$cdnUrl}/imperialGlory/banner.png?v=1`" />
        <div :class="$style.button">
          <img :src="`${$cdnUrl}/imperialGlory/banner-inner.png`" @click="lottery" />
          <img
            :class="`${$style.aorrow} ${lotteryRun ? $style.aorrowRun : ''}`"
            :src="`${$cdnUrl}/imperialGlory/banner-out.png?v=1`"
            :style="{
              transform: `translate3d(-50%, -50%, 0) rotateZ(${lotteryDeg}deg)`,
            }"
          />
        </div>
      </div>
      <p>
        剩余抽奖次数：<span :class="$style.lotteryDay">{{ surplusLotteryNum }}</span>
      </p>
    </div>
    <!-- 称号福利 -->
    <div
      :class="$style.welfare"
      :style="{ backgroundImage: `url('${$cdnUrl}/imperialGlory/bg04.gif')` }"
    ></div>
    <!-- 活动规则 -->
    <div
      :class="$style.rule"
      :style="{ backgroundImage: `url('${$cdnUrl}/imperialGlory/bg05.jpg')` }"
    >
      <div v-for="(item, index) in ruleList" :key="index">
        <h4>{{ item.title }}：</h4>
        <p v-for="(m, i) in item.list" :key="`${index}-${i}`">{{ m }}</p>
      </div>
    </div>
    <!-- 活动状态弹窗 -->
    <Dialog :class="$style.dialog" v-show="status !== 1">
      <div :class="$style.placeholder"></div>
      <div v-if="status === 0">
        <p :class="$style.line">吴镇宇福利节将于8月25日10点开启！</p>
        <p :class="$style.line">超多钥匙礼包等你拿！更有华为手机等你抽！</p>
        <p :class="$style.line">勇士们届时记得来哦。</p>
      </div>
      <p :class="$style.line" v-if="status === 2">
        吴镇宇福利节已经结束，请勇士们关注论坛其他活动哦~
      </p>
    </Dialog>
    <!-- 礼包弹窗 - 未到达领取条件 -->
    <Dialog :class="$style.dialog" v-show="missShow">
      <img :class="$style.close" :src="`${$cdnUrl}/imperialGlory/dialog-big-close.png`" alt="" />
      <p :class="$style.line">未满足领取条件</p>
      <p :class="$style.line">{{ `再累计签到（${missDay}）天即可领取~` }}</p>
      <div :class="$style.btn" @click="missShow = false">确定</div>
    </Dialog>
    <!-- 任务提醒弹窗 -->
    <Dialog :class="$style.dialog" v-show="messionShow">
      <div :class="$style.placeholder"></div>
      <p :class="$style.line">完成任务签到成功才能领取奖励哦～</p>
      <div :class="$style.btn" @click="messionShow = false">确定</div>
    </Dialog>
    <!-- 礼包弹窗 - 可领取状态 -->
    <Dialog :class="$style.dialog" v-show="giftShow">
      <h2>礼包内容：</h2>
      <div :class="$style.content">
        <img :class="$style.giftIcon" :src="`${$cdnUrl}/imperialGlory/dialog-gift.png`" alt="" />
        <ul>
          <li v-for="(item, index) in currentContent" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="copyBtn" :class="$style.btn" @click="() => {}">复制礼包码</div>
    </Dialog>
    <!-- 复制成功弹窗 -->
    <Dialog :class="$style.dialog" v-show="copyShow">
      <div :class="$style.placeholder"></div>
      <p :class="$style.line">礼包码复制成功，请进入游戏兑换～</p>
      <div
        :class="$style.btn"
        @click="
          copyShow = false;
          lotteryRound = 0;
        "
      >
        确定
      </div>
    </Dialog>
    <!-- 抽奖弹窗 -->
    <Dialog :class="$style.dialog" v-show="lotteryShow">
      <p :class="$style.line">恭喜抽中{{ currentLottery.reward_name }}</p>
      <p :class="$style.line">礼包码：{{ currentLottery.gift_code }}</p>
      <div class="lotteryBtn" :class="$style.btn" @click="() => {}">复制礼包码</div>
    </Dialog>
    <!-- 中奖记录 -->
    <Dialog
      :class="$style.dialog"
      :title="'中奖记录'"
      @close="lotteryRecordShow = false"
      v-show="lotteryRecordShow"
    >
      <div v-if="lotteryRecord.length === 0" :class="$style.section">暂无中奖记录</div>
      <ul :class="$style.recordList" v-else>
        <li v-for="(item, index) in lotteryRecord" :key="index">
          <p>{{ `中奖时间：${item.created_at}` }}</p>
          <p>{{ `中奖奖品：${item.name}` }}</p>
          <p>{{ `礼包码：${item.remark}` }}</p>
        </li>
      </ul>
    </Dialog>
    <!-- 签到到达时间点获得抽奖机会弹窗 -->
    <div v-show="chanceShow" :class="$style.chance" @touchmove.prevent>
      <div
        :class="$style.content"
        :style="{ backgroundImage: `url('${$cdnUrl}/imperialGlory/chance-bg.png')` }"
      >
        <img
          v-if="totalSignInDay == 5"
          :class="$style.word"
          :src="`${$cdnUrl}/imperialGlory/chance-5.png`"
        />
        <img
          v-if="totalSignInDay == 10"
          :class="$style.word"
          :src="`${$cdnUrl}/imperialGlory/chance-10.png`"
        />
        <img
          :class="$style.btn"
          :src="`${$cdnUrl}/imperialGlory/chance-try.png`"
          @click="tryLottery"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from './components/imperialGlory/Dialog.vue';
import {
  signInLotteryInfo,
  signInLotteryUserInfo,
  signInLotteryGetGift,
  signInLotteryLottery,
  signInLotteryGetLog,
} from '@/api/activity';
import { mapMutations, mapState } from 'vuex';
import Clipboard from 'clipboard';
import { reportData } from '@/api/report';

export default {
  components: { Dialog },
  data() {
    return {
      actId: 0, // 活动id
      status: -1, // 活动状态 0 未开启 1 进行中 2 已结束
      giftList: [
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift01.png`,
          status: 0,
          sort: '1',
          content: ['羽毛×10', '高阶合成符×1', '天书精华（中）', '金砖×1'],
        },
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift02.png`,
          status: 0,
          sort: '2',
          content: ['羽毛×10', '高阶合成符×1', '天书精华（中）', '金砖×1'],
        },
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift03.png`,
          status: 0,
          sort: '3',
          content: ['特殊称号礼包×10', '高阶合成符×1', '天书精华（中）', '金砖×1'],
        },
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift04.png`,
          status: 0,
          sort: '7',
          content: ['寻宝钥匙×10', '高阶合成符×2', '美女魂卡×1', '金砖×2'],
        },
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift05.png`,
          status: 0,
          sort: '10',
          content: ['寻宝钥匙×20', '高阶合成符×2', '美女魂卡×1', '金砖×2'],
        },
        {
          imgUrl: `${this.$cdnUrl}/imperialGlory/gift06.png`,
          status: 0,
          sort: '14',
          content: ['寻宝钥匙×30', '高阶合成符×2', '美女魂卡×1', '金砖×2'],
        },
      ],
      ruleList: [
        {
          title: '活动时间',
          list: ['2021年8月25日10点00分-2021年9月7日23点59分。'],
        },
        {
          title: '完成任务规则',
          list: [
            '1.玩家在本活动页完成圈子注册或在圈子内完成注册，则完成任务一，每位玩家仅需完成1次。',
            '2.完成圈子注册的玩家每天0点00分-24点内在“帝王荣耀”游戏圈点击过任意帖子即算完成任务二。',
          ],
        },
        {
          title: '参与方式',
          list: [
            '1.活动期间玩家每日进入活动页完成任务一，任务二即可完成累积签到，累积签到1天、 2天、3天、7天、10天、14天分别可领对应的活动礼包。',
            '2.玩家累积签到5天获得1次轮盘抽奖机会，累积签到10天获得1次轮盘抽奖机会。',
            '每位玩家共有2次抽奖机会。玩家点击抽奖按钮即可完成抽奖！',
            '抽奖实物获奖的幸运玩家不要忘了在弹出中奖信息后提交收件信息哦！',
          ],
        },
        {
          title: '兑换流程',
          list: [
            '1.礼包兑换流程：领取到礼包的玩家点击弹窗的复制礼包码，前往【游戏内--福利大厅--激活兑换码】处兑换。',
            '2.抽奖获奖玩家请及时填写收件信息，活动官方会在活动结束后14个工作日内寄出对应奖品。获奖玩家的收件信息填写截止于2021年9月13日23点59分。逾期未填信息将自动视为放弃。',
          ],
        },
        {
          title: '注意事项',
          list: [
            '1. 若在活动过程中遇到任何问题，请联系帝王荣耀官方客服。',
            '2. 玩家每个累签礼包仅能领取一次，每个礼包仅能兑换一次。',
            '3. 抽奖福利中奖率概率为100%，玩家中奖后可在中奖记录中查看。',
            '4. 玩家领到礼包请及时兑换，避免逾期无法兑换，活动时间结束后将会无法查看礼包码。',
            '5. 本活动最终解释权归官方所有。',
          ],
        },
      ],
      lotteryRun: false, // 是否进行转盘动画
      lotteryRound: 0, // 转盘转几圈
      lotteryTimer: null, // 抽奖定时器
      task1: 0, // 任务1是否已完成 1 完成 0 未完成
      task2: 0, // 任务2是否已完成 1 完成 0 未完成
      todaySignIn: 0, // 今日是否已签到 1 是 0 否
      totalSignInDay: 0, // 累计签到天数
      surplusLotteryNum: 0, // 剩余抽奖次数
      missShow: false, // 礼包弹窗 - 未到达领取条件
      missDay: 0, // 还需领取几天
      messionShow: false, // 任务完成弹窗
      currentContent: null, // 当前领取的礼包
      currentGiftCode: '', // 当前领取的礼包码
      giftShow: false, // 礼包弹窗
      copyShow: false, // 复制成功弹窗
      currentLottery: {}, // 当前抽中的奖品
      lotteryShow: false, // 抽奖弹窗
      lotteryRecordShow: false, // 中奖记录弹窗
      lotteryRecord: [], // 中奖记录
      chanceShow: false, // 签到到达时间点获得抽奖机会弹窗
    };
  },
  computed: {
    ...mapState('app', { showRegisterDialog: 'showRegisterDialog' }),
    lotteryDeg() {
      return this.lotteryRound === 0 ? 0 : this.lotteryRound * 360 + 180;
    },
  },
  created() {
    this.getSignInLotteryInfo();
    reportData({ type: 12 });
  },
  mounted() {
    this.copyInit();
  },
  watch: {
    showRegisterDialog(newVal, old) {
      this.getSignInLotteryInfo();
    },
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_SHARE_MASK: 'CHANGE_SHARE_MASK',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG',
    }),
    copyInit() {
      // 礼包领取成功弹窗中点击复制
      this.copy = new Clipboard('.copyBtn', {
        text: () => {
          return this.currentGiftCode;
        },
      });
      this.copy.on('success', (e) => {
        this.giftShow = false;
        this.copyShow = true;
      });
      this.lotteryCopy = new Clipboard('.lotteryBtn', {
        text: () => {
          return this.currentLottery.gift_code;
        },
      });
      this.lotteryCopy.on('success', (e) => {
        this.lotteryShow = false;
        this.copyShow = true;
      });
    },
    // 获取帝王荣耀活动页信息
    async getSignInLotteryInfo() {
      const { data, code } = await signInLotteryInfo();
      if (code !== 1) return;
      this.status = data.state;
      this.actId = data.id;
      // 设置礼包相关
      this.giftList.map((m) => {
        const obj = data.gift.filter((n) => n.sort == m.sort)[0];
        return obj ? Object.assign(m, obj) : m;
      });
      this.getSignInLotteryUserInfo(data.id);
    },
    // 获取用户活动情况
    async getSignInLotteryUserInfo(id) {
      const { data, code } = await signInLotteryUserInfo({ lucky_draw_id: id });
      if (code !== 1) return;
      this.task1 = data.task1;
      this.task2 = data.task2;
      this.todaySignIn = data.today_sign_in;
      this.totalSignInDay = data.total_sign_in_day;
      this.surplusLotteryNum = data.surplus_lottery_num;
      // 设置礼包相关
      this.giftList.map((m) => {
        const obj = data.get_gift_id.filter((n) => n.gift_id == m.gift_id)[0];
        m.sort <= data.total_sign_in_day && Object.assign(m, { status: 1 });
        return obj ? Object.assign(m, obj, { status: 2 }) : m;
      });
      // 连续签到天数判断
      if (data.total_sign_in_day == 5) {
        const f = localStorage.getItem('signDay5') || '';
        console.log(f);
        f !== '1' && (this.chanceShow = true);
      } else if (data.total_sign_in_day == 10) {
        const f = localStorage.getItem('signDay10') || '';
        f !== '1' && (this.chanceShow = true);
      }
    },
    tryLottery() {
      this.chanceShow = false;
      // 连续签到天数判断
      if (this.totalSignInDay == 5) {
        localStorage.setItem('signDay5', '1');
      } else if (this.totalSignInDay == 10) {
        localStorage.setItem('signDay10', '1');
      }
    },
    // 点击跳转到帝王荣耀圈子
    jumpCircle() {
      this.$router.push({ name: 'gameCircle.home', query: { circleId: '20' } });
    },
    // 点击领取礼包
    async getGift(item) {
      // 未完成任务
      if (this.task1 == 0 || this.task2 == 0) {
        this.messionShow = true;
        return;
      }
      // 不可领取状态
      if (item.status == 0) {
        this.missDay = item.sort - this.totalSignInDay;
        this.missShow = true;
        return;
      } else if (item.status == 1) {
        // 领取上报
        await this.getSignInLotteryGetGift(item.gift_id);
      }
      this.currentContent = item['content'];
      this.currentGiftCode = item['code'];
      this.giftShow = true;
    },
    // 实际领取礼包
    async getSignInLotteryGetGift(id) {
      const { data, code } = await signInLotteryGetGift({ gift_id: id });
      if (code !== 1) return;
      // 设置礼包相关
      this.giftList.map((m) => {
        return data.gift_id == m.gift_id ? Object.assign(m, data, { status: 2 }) : m;
      });
    },
    // 点击抽奖
    lottery() {
      if (this.lotteryRun) return;
      if (this.surplusLotteryNum == 0) {
        this.$toast.fail('暂无抽奖次数');
        return;
      }

      // 未完成任务
      if (this.task1 == 0 || this.task2 == 0) {
        this.messionShow = true;
        return;
      }

      clearInterval(this.lotteryTimer);
      this.lotteryRun = true;
      this.lotteryRound = 2;
      this.lotteryTimer = setInterval(() => this.lotteryRound++, 1000);
      signInLotteryLottery()
        .then((r) => {
          clearInterval(this.lotteryTimer);
          this.currentLottery = r.data;
          setTimeout(() => {
            this.lotteryShow = true;
            this.lotteryRun = false;
            this.getSignInLotteryUserInfo(this.actId);
          }, this.lotteryRound * 1000);
        })
        .catch((err) => {
          this.$toast.fail(err.message);
          clearInterval(this.lotteryTimer);
          this.lotteryRun = false;
          this.getSignInLotteryUserInfo(this.actId);
        });
    },
    // 点击中奖记录
    showLotteryRecord() {
      signInLotteryGetLog()
        .then((r) => {
          this.lotteryRecord = r.data;
          this.lotteryRecordShow = true;
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  background-color: #361e1d;
  font-family: Microsoft YaHei;
  color: #fefcdb;
  .top {
    width: 100%;
    height: 360px;
    background-size: 100%;
    background-repeat: no-repeat;
    padding-top: 216px;
    position: relative;
    > p {
      width: 100%;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      line-height: 30px;
      .red {
        font-size: 21px;
        font-weight: bold;
        color: #ff3b34;
      }
    }
    > span {
      font-size: 10px;
      font-weight: 400;
      color: #ffd042;
      text-decoration: underline;
      position: absolute;
      right: 28px;
      top: 230px;
    }
    .mession {
      width: 335px;
      height: 39px;
      background: #75070e;
      border: 1px solid rgba(249, 238, 195, 0.81);
      opacity: 0.8;
      border-radius: 2px;
      box-shadow: 0px 0px 7px #ff3b34 inset;
      margin: 3px auto 5px auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 30px;
      font-size: 12px;
      font-weight: 400;
      img {
        width: 14px;
      }
      > span:nth-child(2) {
        display: flex;
        align-items: center;
        min-width: 60px;
        > img {
          margin-left: 6px;
        }
      }
      .after {
        display: block;
        width: 6px;
        height: 6px;
        border-width: 1px 1px 0px 0px;
        border-color: #fefcdb;
        border-style: solid;
        transform: rotateZ(45deg);
        margin-left: 3px;
      }
      .after::after {
        content: '';
        width: 6px;
        height: 6px;
        border-width: 1px 1px 0px 0px;
        border-color: #fefcdb;
        border-style: solid;
        position: absolute;
        left: 2px;
        top: -4px;
      }
    }
  }
  .gift {
    width: 100%;
    height: 256px;
    background-repeat: no-repeat;
    background-size: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 40px 60px 10px 60px;
    > div {
      width: 77px;
      height: 94px;
      position: relative;
      .giftItem {
        width: 100%;
      }
      .giftBtn {
        width: 23px;
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
  }
  .lottery {
    width: 100%;
    height: 394px;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    padding: 44px 0px 0px 0px;
    > span {
      position: absolute;
      text-decoration: underline;
      font-size: 10px;
      font-weight: 400;
      color: #ff1800;
      right: 40px;
      top: 24px;
    }
    > p {
      width: 100%;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      > span {
        color: #ff3b34;
      }
      .lotteryDay {
        font-size: 21px;
        font-weight: bold;
      }
    }
    > div {
      width: 290px;
      height: 290px;
      margin: 10px auto 10px auto;
      position: relative;
      > img:nth-child(1) {
        width: 290px;
      }
      .button {
        width: 100px;
        height: 100px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        > img:nth-child(1) {
          width: 72px;
          z-index: 5;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
        .aorrow {
          width: 100px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0) rotateZ(0deg);
        }
        .aorrowRun {
          transition: all 2s linear;
        }
      }
    }
  }
  .welfare {
    width: 100%;
    height: 303px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .rule {
    width: 100%;
    height: 448px;
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 30px 17px 0px 17px;
    font-size: 8px;
    font-weight: bold;
    line-height: 17px;
    > div {
      > h4 {
        color: #f9d782;
      }
      > p {
        padding-left: 10px;
      }
    }
  }
  .dialog {
    font-family: Microsoft YaHei;
    .recordList {
      width: 100%;
      height: 150px;
      overflow-y: auto;
      > li {
        width: 100%;
        height: 75px;
        border-bottom: 1px solid #fcecc0;
        > p {
          width: 100%;
          font-size: 13px;
          font-weight: 400;
          color: #fdf4d4;
          line-height: 21px;
        }
      }
    }
    .close {
      width: 55px;
      display: block;
      margin: 0 auto 10px auto;
    }
    .section {
      width: 100%;
      height: 100px;
      text-align: center;
      line-height: 100px;
    }
    .line {
      width: 100%;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      line-height: 26px;
    }
    .btn {
      width: 92px;
      height: 22px;
      background: linear-gradient(0deg, #fef9e3, #f9d47b);
      border-radius: 11px;
      font-size: 14px;
      font-weight: 400;
      color: #680c11;
      text-align: center;
      line-height: 22px;
      margin: 10px auto 0px auto;
      cursor: pointer;
    }
    .placeholder {
      width: 100%;
      height: 10px;
    }
    h2 {
      font-size: 17px;
      font-family: FZDaBiaoSong-B06S;
      font-weight: 400;
      color: #ffffdb;
      line-height: 20px;
      margin-bottom: 20px;
    }
    .content {
      width: 100%;
      height: 72px;
      // background-color: pink;
      display: flex;
      justify-content: space-around;
      margin-bottom: 20px;
      .giftIcon {
        width: 93px;
      }
      ul {
        width: 70px;
        height: 100%;
        li {
          font-size: 10px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffdb;
          line-height: 18px;
        }
      }
    }
  }
  .chance {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);

    .content {
      width: 242px;
      height: 223px;
      margin: 200px auto;
      // background-color: pink;
      background-repeat: no-repeat;
      background-size: 100%;
      background-position: 4px -40px;
      position: relative;

      .btn {
        width: 121px;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 5;
      }
      .word {
        width: 130px;
        position: absolute;
        bottom: 46px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>